import { Card as AntdCard, List as AntdList, Icon as AntdIcon } from 'antd'
import AntdText from 'antd/lib/typography/Text'
import AntdItem from 'antd/lib/list/Item'
import styled from 'styled-components'

export const Card = styled(AntdCard)`
  margin: 3rem;
`

export const List = styled(AntdList)`
  min-width: 70rem;
` as React.ComponentType as new <T>() => AntdList<T>

export const ListItem = styled(AntdItem)`
  max-width: 70rem;
  min-height: 6rem;
  min-width: 30rem;
  padding: 0 2rem 0 0;
`

export const Text = styled(AntdText)`
  min-width: 5rem;
`

export const ListItemImageSpan = styled.span`
  min-width: 2rem;
  max-width: 6rem;
`

export const ListItemAmount = styled(AntdText)`
  color: #cf1322;
  font-size: larger;
  font-weight: bold;
  min-width: 8rem;
`

export const ListItemImage = styled.img`
  height: 5rem;
  object-fit: cover;
`

export const Icon = styled(AntdIcon)`
  font-size: 28px;
  padding: 1rem;
`
